import { isPageVisible, onVisibilityChange } from "./pageVisibility";

const PAUSED_KEY = "wesAutoplayPaused";
const CAROUSEL_SELECTOR = ".owl-carousel";

let wired = false;

const eachCarousel = (fn) => {
  const $ = window.jQuery;
  if (!$) return;
  $(CAROUSEL_SELECTOR).each(function () {
    const $el = $(this);
    const core = $el.data("owl.carousel");
    if (core) fn($el, core);
  });
};

const pauseOne = ($el, core) => {
  if (!core.settings || !core.settings.autoplay || !core.is("rotating")) return;
  $el.data(PAUSED_KEY, true);
  $el.trigger("stop.owl.autoplay");
};

const resumeOne = ($el) => {
  if (!$el.data(PAUSED_KEY)) return;
  $el.removeData(PAUSED_KEY);
  $el.trigger("play.owl.autoplay");
};

const applyVisibility = (visible) => {
  if (visible) {
    eachCarousel(resumeOne);
  } else {
    eachCarousel(pauseOne);
  }
};

export const startOwlAutoplayVisibility = () => {
  if (wired || typeof document === "undefined") return () => {};
  const $ = window.jQuery;
  if (!$) return () => {};
  wired = true;

  const onInitialized = (event) => {
    if (isPageVisible()) return;
    const $el = $(event.target);
    const core = $el.data("owl.carousel");
    if (core) pauseOne($el, core);
  };

  $(document).on("initialized.owl.carousel", onInitialized);
  const unsubscribe = onVisibilityChange(applyVisibility);

  return () => {
    $(document).off("initialized.owl.carousel", onInitialized);
    unsubscribe();
    wired = false;
  };
};
